import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/app/dialog/dialog";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DialogProps {
  setIsDialogOpen: (value: boolean) => void;
  image: string;
  isOpen: boolean;
}

export function DialogViewImage({ setIsDialogOpen, image, isOpen }: DialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={setIsDialogOpen}>
      <DialogContent isShowBtnXClose={false} className="max-w-full lg:max-w-[700px] h-[calc(100vh-80px)] py-2 px-0 flex flex-col" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="mt-2 text-center">{t("View Image")}</DialogTitle>

          <div
            className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>

        <div className="flex flex-grow w-full h-full  overflow-auto ">
          <img src={image} alt="Preview" className="w-full h-auto rounded-lg object-contain" />
        </div>
      </DialogContent>
    </Dialog>
  );
}

